// Initialize complementary products slider
(function () {
  const initComplementarySlider = () => {
    const sliders = document.querySelectorAll('.js-complementary-swiper');
    
    console.log('Found', sliders.length, 'complementary sliders');
    
    sliders.forEach((slider) => {
      // Destroy existing instance if present
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      const container = slider.closest('.complementary-products__container');
      if (!container) {
        console.log('No container found for slider');
        return;
      }

      const slides = slider.querySelectorAll('.swiper-slide');
      console.log('Found', slides.length, 'slides in complementary slider');
      
      // Only initialize if there are slides
      if (slides.length === 0) return;

      // Find navigation buttons within the same container
      const nextButton = container.querySelector('.complementary-products__navigation-button-next');
      const prevButton = container.querySelector('.complementary-products__navigation-button-prev');

      console.log('Next button:', nextButton);
      console.log('Prev button:', prevButton);

      const swiperInstance = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        allowTouchMove: true,
        centeredSlides: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
          disabledClass: 'swiper-button-disabled',
        },
        loop: false,
        watchOverflow: true,
        on: {
          init: function() {
            console.log('✓ Complementary slider initialized with', this.slides.length, 'slides');
            console.log('Active index:', this.activeIndex);
          },
          slideChange: function() {
            console.log('Slide changed to:', this.activeIndex);
          }
        }
      });

      console.log('Swiper instance created:', swiperInstance);
    });
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComplementarySlider);
  } else {
    // Use small delay to ensure DOM is fully rendered
    setTimeout(initComplementarySlider, 300);
  }

  // Reinitialize on section reload (theme editor)
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initComplementarySlider, 300);
  });
})();

